import { Group } from '@visx/group';

import { useTheme } from '@simplywallst/ui-core';

import type { HierarchyPointNode } from '../../types';

import { VisxText } from '@/components/VisxText';

import { useTruncatedName } from '../../hooks';
import { useSVGElementWidth } from '@/hooks/useSVGElementWidth';
import { formatterPercentage } from '@/utilities/format';

type Props = {
  node: HierarchyPointNode;
  onClick?: () => void;
};

export const Industry = ({ node, onClick }: Props) => {
  const theme = useTheme();
  const [ref, width] = useSVGElementWidth();
  const [refPercent, percentWidth] = useSVGElementWidth();
  const totalWidth = width + theme.x0_75 + percentWidth + theme.x5;
  const name = useTruncatedName(node.data.name);
  return (
    <Group
      top={node.x}
      left={node.y + theme.x2}
      onClick={() => onClick?.()}
      data-cy-id={`industry-${node.data.name}`}
      style={{ cursor: 'pointer' }}
    >
      <rect
        transform={`translate(-${theme.x1},-${theme.x1_5})`}
        width={totalWidth}
        height={theme.x3}
        rx={8}
        fill={theme.color.brand03RGBA(0.1)}
      />
      <VisxText
        innerRef={ref}
        typography="xSmall"
        verticalAnchor="middle"
        fill={theme.color.white}
      >
        {name}
      </VisxText>

      <VisxText
        innerRef={refPercent}
        x={width + theme.x0_75}
        typography="xSmall"
        verticalAnchor="middle"
        fill={theme.color.whiteRGBA(0.5)}
      >
        {formatterPercentage(node.data.weight)}
      </VisxText>

      <Group left={width + theme.x0_75 + percentWidth + theme.x2}>
        <circle r="10" fill={theme.color.brand01} />
        <VisxText
          typography="tiny"
          verticalAnchor="middle"
          textAnchor="middle"
          fill={theme.color.white}
        >
          {node.data.childCount}
        </VisxText>
      </Group>
    </Group>
  );
};
